import { Fragment, useMemo } from 'react';
import cl from 'classnames';
import map from 'lodash/map';
import groupBy from 'lodash/groupBy';

import { useInvoiceItemsViewContext } from '../../hooks/useInvoiceItemsViewContext';

import { InvoiceItemsViewTableGroupRowsHeader } from '../InvoiceItemsViewTableGroupRowsHeader';
import { InvoiceItemsViewTableRow } from '../InvoiceItemsViewTableRow';

import { getInvoiceItemsViewGroupKey } from '../../utils/getInvoiceItemsViewGroupKey';

interface InvoiceItemsViewTableBodyProps {
  readonly?: boolean;
}

const itemsWithoutPageBreak = 12;

function InvoiceItemsViewTableBody({
  readonly
}: InvoiceItemsViewTableBodyProps) {
  const { items, watchFields } = useInvoiceItemsViewContext();

  const groupedItems = useMemo(
    () =>
      groupBy(items, (item) =>
        getInvoiceItemsViewGroupKey({
          item,
          enableGrouping: watchFields.watchEnableGrouping,
          groupBy: watchFields.watchGroupBy
        })
      ),
    [items, watchFields.watchEnableGrouping, watchFields.watchGroupBy]
  );

  return (
    <tbody>
      {map(groupedItems, (items, key) => (
        <Fragment key={key}>
          {key ? (
            <InvoiceItemsViewTableGroupRowsHeader
              items={items}
              readonly={readonly}
            />
          ) : (
            <tr className="h-2 !border-t-0"></tr>
          )}

          {map(items, (item, index) => (
            <InvoiceItemsViewTableRow
              className={cl(
                'h-group',
                items.length <= itemsWithoutPageBreak
                  ? 'break-before-avoid'
                  : ''
              )}
              item={item}
              index={index}
              key={index}
              readonly={readonly}
            />
          ))}

          <tr className="h-2 !border-t-0 break-before-avoid"></tr>
        </Fragment>
      ))}
    </tbody>
  );
}

export default InvoiceItemsViewTableBody;
